import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import axios from 'axios'
import '@/App.css' 
import PrimeVue, { defaultOptions } from 'primevue/config';
import 'primevue/resources/themes/aura-light-green/theme.css'
import 'primeicons/primeicons.css'
import ToastService from 'primevue/toastservice';
import ConfirmationService from 'primevue/confirmationservice'; 
import Tooltip from 'primevue/tooltip'
import { env } from "@/composables/config";
import { watch } from 'vue';
import { cookieChoice, optionalAllowed } from '@/composables/cookieConsent';
import { createOptionalScripts } from '@/services/optionalScripts.mjs';
import { loadTranslations } from "@/composables/translate";
import { initialInterfaceLanguage, interfaceLanguages } from "@/composables/interfaceLanguage";
import { installNativeValidation } from "@/composables/nativeValidation.mjs";
import { primeVueLocale } from '@/i18n/primeVueLocale.mjs';

async function bootstrap() {
    const initialLanguage = initialInterfaceLanguage();
    await store.dispatch('changeLanguage', { langIso: initialLanguage, langName: interfaceLanguages[initialLanguage] });
    await loadTranslations(initialLanguage);
    watch(() => store.getters.getUserLang, language => { document.documentElement.lang = language; }, { immediate: true });
    installNativeValidation(document, () => store.getters.getUserLang);

    const app = createApp(App)
    app.use(ToastService);
    app.use(ConfirmationService);
    app.use(PrimeVue, {
        ripple: true,
        locale: primeVueLocale(initialLanguage, defaultOptions.locale)
    })
    watch(() => store.getters.getUserLang, language => {
        app.config.globalProperties.$primevue.config.locale = primeVueLocale(language, defaultOptions.locale);
    }, { flush: 'sync' });
    app.use(store)
    const optionalScripts = createOptionalScripts({ win: window, doc: document,
        analyticsId: env('APP_GOOGLE_ANALYTICS_ID'), supportProperty: env('APP_TAWKTO_SECRET'), supportWidget: env('APP_TAWKTO_ID') });
    watch(cookieChoice, () => optionalScripts.apply({ analytics: optionalAllowed('analytics'), support: optionalAllowed('support') }), { immediate: true });
    router.afterEach(() => { if (optionalAllowed('analytics')) optionalScripts.pageView(); });
    app.use(router)
    app.config.globalProperties.$axios = axios
    app.directive('tooltip', Tooltip);
    app.mount('#app')
}

bootstrap();
